import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-8">Privacy Policy</h1>
      <div className="prose max-w-3xl">
        <p>
          At iReview.ai, we guard your data like a robot guard dog 🐕🤖 with laser eyes 🔫👀. 
          This policy explains in plain English (and lots of emojis 💬✨) how we handle your info - 
          we pinky-promise 🤙 we're not secretly training on your browsing habits (unless you 
          explicitly opt-in to help your friendly AI reviewers 🤓📊 learn and improve).
        </p>
        <h2 className="text-xl font-bold mt-6">Information We Collect</h2>
        <p>
          We may collect personal information such as your name, email address, and usage data
          when you interact with our website. This information is used to improve our services
          and provide you with a better user experience.
        </p>
        <h2 className="text-xl font-bold mt-6">How We Use Your Information</h2>
        <p>
          Your information is used to:
          <ul>
            <li>Provide and improve our services</li>
            <li>Respond to your inquiries and requests</li>
            <li>Send you important updates and notifications</li>
            <li>Analyze website usage and trends</li>
          </ul>
        </p>
        <h2 className="text-xl font-bold mt-6">Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your information from
          unauthorized access, alteration, or disclosure. However, no method of transmission
          over the internet is 100% secure, and we cannot guarantee absolute security.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
